$(function () {

    var $body = $('body');
    // move the mobile nav to the end of the body to avoid IE bug
    $body.append($('.mobile-nav'));

    var $mobileMenuToggle = $('.mobile-nav-toggle');

    var mobileMenuToggleClass = 'mobile-nav--opened';
    var sideMenuClass = 'side-menu--opened';
    var sideMenuVisibility = 'side-menu-visible';

    $mobileMenuToggle.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $body.toggleClass(mobileMenuToggleClass);
        $('.mobile-nav').toggleClass(sideMenuVisibility);
    });

    $body.on('click', function (e) {
        if (!$(e.target).parents('.mobile-nav').length && !$(e.target).hasClass('mobile-nav')) {
            $body.removeClass(mobileMenuToggleClass);
            $('.mobile-nav').removeClass(sideMenuClass).removeClass(sideMenuVisibility);
        }
    });

    var newheader = $('.cc-header');
    if (newheader) {
        var searchToggle = $('.header-search_control');
        var mobileToggle = $('.mobile-nav-btn');
        var mainNav = $('.cc-header_main-nav');
        var utilNav = $('.cc-header_util-nav');
        var searchWrapper = $('#headerSearch');

        searchToggle.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            searchWrapper.toggleClass('open');
            searchToggle.attr('aria-expanded', searchWrapper.hasClass('open').toString());
            if (matchMedia("(max-width: 1023.98px)").matches) {
                if (searchWrapper.hasClass('open')) {
                    utilNav.collapse('show');
                }
                else if (!searchWrapper.hasClass('open') && mainNav.attr('aria-expanded') != 'true') {
                    utilNav.collapse('hide');
                }

                mainNav.collapse('hide');
            }
        });

        mobileToggle.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            mainNav.collapse('toggle');

            if (!searchWrapper.hasClass('open')) {
                utilNav.collapse('toggle');
            }
            else {
                searchWrapper.removeClass('open');
            }            
        });

        $body.on('click', function (e) {
            if (!$(e.target).parents('.cc-header').length && !$(e.target).hasClass('cc-header')) {
                if (searchWrapper.hasClass('open')) {
                    searchWrapper.removeClass('open');
                    searchToggle.attr('aria-expanded', 'false');
                }

                mainNav.collapse('hide');
                utilNav.collapse('hide');
            }
        });
    }
});